import { z } from 'zod';
/**
 * In-app notifications (REQUIREMENTS §2.4 `notifications`). In-app only:
 * there is no email or SMS notification anywhere in this app.
 *
 * `title` and `body` are i18n keys (`notifications.<type>.title`), rendered
 * in the reader's language with `params`. A Hebrew string stored in the
 * database would be wrong for an English reader forever.
 */
export const notificationSchema = z.object({
    id: z.string().min(1),
    type: z.string().min(1),
    title: z.string().min(1),
    body: z.string().min(1),
    params: z.record(z.string(), z.union([z.string(), z.number()])),
    linkTo: z.string(),
    read: z.boolean(),
    createdAt: z.string().nullable(),
});
/** GET /api/notifications — the caller's own, newest first. */
export const NOTIFICATIONS_PAGE = 50;
export const notificationsResponseSchema = z.object({
    notifications: z.array(notificationSchema),
    /** Across everything, not just the page returned. */
    unread: z.number().int().min(0),
});
/** POST /api/notifications/read — mark some, or every one, as read. */
export const markReadRequestSchema = z.object({
    ids: z.union([z.literal('all'), z.array(z.string().min(1)).min(1).max(100)]),
});
export const markReadResponseSchema = z.object({ unread: z.number().int().min(0) });
//# sourceMappingURL=notifications.js.map